import { Sun, Moon } from 'lucide-react';
import { useTheme, THEMES } from '../context/ThemeContext';
import { Label } from '@/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/ui/select';
import { Button } from '@/ui/button';

export const ThemeToggle = ({ variant = 'select' }) => {
  const { theme, setTheme, toggleTheme } = useTheme();
  const isLight = theme === THEMES.LIGHT;

  if (variant === 'button') {
    return (
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleTheme}
        className="h-9 w-9 rounded-lg"
        title={`Switch to ${theme === THEMES.DARK ? 'light' : 'dark'} mode`}
        data-testid="theme-toggle-btn"
      >
        {theme === THEMES.DARK ? (
          <Sun className="h-5 w-5 text-yellow-400" />
        ) : (
          <Moon className="h-5 w-5 text-indigo-500" />
        )}
      </Button>
    );
  }

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        {theme === THEMES.DARK ? (
          <Moon className="h-5 w-5 text-slate-400" />
        ) : (
          <Sun className="h-5 w-5 text-yellow-500" />
        )}
        <div>
          <Label className={`text-sm font-medium ${isLight ? 'text-gray-900' : ''}`}>Theme</Label>
          <p className={`text-xs ${isLight ? 'text-gray-500' : 'text-slate-500'}`}>Choose your preferred appearance</p>
        </div>
      </div>
      <Select value={theme} onValueChange={setTheme}>
        <SelectTrigger 
          className={`w-28 ${isLight ? 'bg-white border-gray-300' : 'bg-slate-900 border-slate-700'}`}
          data-testid="theme-select"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent className={isLight ? 'bg-white border-gray-200' : 'bg-slate-800 border-slate-700'}>
          <SelectItem value={THEMES.DARK}>
            <div className="flex items-center gap-2">
              <Moon className="h-4 w-4" />
              Dark
            </div>
          </SelectItem>
          <SelectItem value={THEMES.LIGHT}>
            <div className="flex items-center gap-2">
              <Sun className="h-4 w-4" />
              Light
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default ThemeToggle;
